export default __webpack_public_path__ + "img/traitegg.32bb3e15.png";